// removed by extract-text-webpack-plugin
module.exports = {"navigateBar":"_2Z8Fig8ufyReLHq7zQSxyS","screen":"_3D5meVKaBqdLVujTVR6q8J","redDot":"gZnWaiJuG5NxbWiebJjdo","text":"CKT90D8vW9BmFPIAc9WHC","icon":"_2jldCirAxqh4mxPPU1jMVV","fiveStarIcon":"_3yelR6EMTS0pXAbhz7-pOD","serviceAtHomeSelected":"_1JZavXpz0iL6tXGE1yqVPu","spaSelected":"JVyA6aZbZx8m9Z0T3dMkD","fiveStarSelected":"_3CdQK4owUTQOsA2vpDSrdz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Home/Promotion.scss
// module id = 1142
// module chunks = 0